import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeQuestionStatus } from "../../../autogen/bff-api";
import { QUESTION_STATUS_COLORS } from "./questionStatusColors";

export const QuestionStatusBadge = ({ status }: { status: SeQuestionStatus }) => {
  const { t } = useTranslation();
  const colors = QUESTION_STATUS_COLORS[status];
  switch (status) {
    case SeQuestionStatus.Unanswered:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Unanswered")}
        </Badge>
      );
    case SeQuestionStatus.Answered:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Answered")}
        </Badge>
      );
    case SeQuestionStatus.Published:
      return (
        <Badge bg={colors.bg} color={colors.fg}>
          {t("Sent")}
        </Badge>
      );
  }
};
